import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as appConstants from "../../../constants/appConstants";
import * as localStorage from '../../../localStorage/localStorage';
import Player from '@vimeo/player';
import * as animationHelper from "../../../helpers/animationHelper";

const MATCH_MESSAGE_ORIGIN = /^https?:\/\/player.vimeo.com/;

class VimeoVideo extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            userData: this.props.userData,
            screenObject: this.props.screenObject,
            video: this.props.video,
            locale: appHelper.getLocalData(this.props.screenObject),
            responseData: {
                latestResponse: {}
            },
            player: {},
            isPlaying: true,
            initialised: false,
            status: objectConstants.STATUS_NOT_STARTED,
            isResourceObject: appHelper.isDefined(this.props.callbacks.checkIsResourceScreen) && this.props.callbacks.checkIsResourceScreen(),
            trackable: true,
            autoplay: true,
            video_instruction: appHelper.getLocaleString("video_instruction"),
        };

        this.initVideoPlayer = this.initVideoPlayer.bind(this);
        this.show = this.show.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.onEndedFunc = this.onEndedFunc.bind(this);
        this.onPauseFunc = this.onPauseFunc.bind(this);
        this.onPlayFunc = this.onPlayFunc.bind(this);
        this.onVideoMessage = this.onVideoMessage.bind(this);
        this.setClass = this.setClass.bind(this);
        this.getObjectStatusClass = this.getObjectStatusClass.bind(this);
        this.getVimeoId = this.getVimeoId.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.customPlay = this.customPlay.bind(this);
        this.getControlClass = this.getControlClass.bind(this);
        this.setStatusClass = this.setStatusClass.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);

        this.objectRef = React.createRef();
    }

    componentDidMount() {

        //this.getObjectStatus();
        this.show();
        this.initVideoPlayer();
        window.addEventListener('message', this.onVideoMessage, false);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }
        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                video_instruction: appHelper.getLocaleString("video_instruction"),
            });
        }
    }

    componentDidUpdate() {
        if (appHelper.isDefined(this.state.locale.description) && !this.state.initialised) {
            this.initVideoPlayer();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.onVideoMessage, false);
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.screenObject);
        this.setState({locale: Object.assign({}, locale)});
        if (this.state.screenObject.show_title_in_header) {
            this.props.actions.setScreenTitle(locale.title);
        }
    }

    getObjectStatusClass() {
        let objectUserData = {};
        let subScreenParent = {};
        let screen_id = undefined;
        if (appHelper.isDefined(this.props.callbacks.getSubScreenParent)) {
            subScreenParent = this.props.callbacks.getSubScreenParent();
        }
        if (appHelper.isDefined(this.props.callbacks.getScreenId)) {
            screen_id = this.props.callbacks.getScreenId();
        }

        if (appHelper.isDefined(screen_id)) {
            if (appHelper.isDefined(subScreenParent)) {
                objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
            } else if (this.state.isResourceObject) {
                objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
            } else {
                objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
            }
        } else {
            objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.screenObject.asset_id);
        }

        if (appHelper.isDefined(objectUserData.status)) {

            if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
                return `complete`;
            } else if (objectUserData.status === objectConstants.STATUS_IN_PROGRESS) {
                return `in-progress`;
            } else if (objectUserData.status === objectConstants.STATUS_NOT_REQUIRED) {
                return `not-required`;
            } else {
                if (this.state.status === objectConstants.STATUS_COMPLETE) {
                    return `complete`;
                } else if (this.state.status === objectConstants.STATUS_IN_PROGRESS) {
                    return `in-progress`;
                } else {
                    return `not-started`;
                }
            }
        }
        return `not-started`;
    }

    initVideoPlayer() {
        const player = new Player(`video_${this.state.screenObject.asset_id}`, {
            id: this.state.locale.vimeo_id,
            width: '100%',
            height: 'auto'
        });

        player.on('play', function () {

        });

        player.on('pause', function () {

        });

        player.on('ended', function () {

        });

        // console.log(`this.state.lang`,this.state.lang)

        player.enableTextTrack(this.state.lang).then(function (track) {
            // track.language = the iso code for the language
            // track.kind = 'captions' or 'subtitles'
            // track.label = the human-readable label
        }).catch(function (error) {
            switch (error.name) {
                case 'InvalidTrackLanguageError':
                    // no track was available with the specified language
                    break;

                case 'InvalidTrackError':
                    // no track was available with the specified language and kind
                    break;

                default:
                    // some other error occurred
                    break;
            }
        });

        this.setState({
            initialised: true,
            player: player
        });
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.props.actions.setVideoOpened(this.state.screenObject.asset_id, this.state.locale.label);
        }
    }

    onVideoMessage(e) {
        if (!MATCH_MESSAGE_ORIGIN.test(e.origin)) return;
        const data = e.data;
        if (data.event === 'play') this.onPlayFunc();
        if (data.event === 'pause') this.onPauseFunc();
        if (data.event === 'ended') this.onEndedFunc();
    }

    handleProgression() {
        this.props.callbacks.onObjectComplete(objectConstants.OBJECT_PROGRESSION_CONTINUE, this.state.screenObject.asset_id, this.state.responseData.latestResponse);
    }

    onEndedFunc(event) {
        //if (this.state.status !== objectConstants.STATUS_COMPLETE) {
        this.props.onAssetViewed();
        //}
        this.setState({isPlaying: false});
        this.setState({status: objectConstants.STATUS_COMPLETE});
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.props.actions.setVideoPlayed(this.state.screenObject.asset_id, this.state.locale.label);
        }
    }

    onPauseFunc(event) {
        this.setState({isPlaying: false});
    }

    onPlayFunc(event) {

        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            this.setState({status: objectConstants.STATUS_IN_PROGRESS});
        }
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.props.actions.setVideoOpened(this.state.screenObject.asset_id, this.state.locale.label);
        }

    }

    setClass() {
        if (this.state.isPlaying) {
            return "playing";
        } else {
            return "";
        }
    }

    setStatusClass() {
        if (this.state.status === objectConstants.STATUS_COMPLETE) {
            return "viewed";
        } else {
            return "not-viewed";
        }

    }

    show() {
        let objectRef = this.objectRef.current;
        if (appHelper.isEleDefined(objectRef)) {
            let params = {
                ele: objectRef,
                duration: objectConstants.SHOW_PANEL_DURATION,
                delay: 0,
                callback: null
            };
            animationHelper.fadeIn(params);
        }
    }

    getVimeoId(src) {

        return src.split('.com/').pop().toLowerCase();

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    customPlay() {
        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            this.setState({status: objectConstants.STATUS_IN_PROGRESS});
        }
        this.state.player.play();
    }

    getControlClass() {
        return this.state.status === objectConstants.STATUS_COMPLETE ? 'replay' : 'play';
    }

    setKeyboardAccessibility(event) {
        if (appHelper.isDefined(event)) {
            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
                event.preventDefault();
                this.customPlay();
            }
        }
    }

    render() {
        return (

                <div className="object-container" ref={this.objectRef}>
                    <div className={`asset-dialog-image`}>
                        <div className="asset-image-header">
                            <div className="title-col truncate-text-container">
                                <div className={`title ${this.getObjectStatusClass()}`}
                                     dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                            </div>
                            <div className="nav-col">
                                <button className={`btn guroo-btn`} onClick={this.props.closeDialog}>
                                    {this.state.status === objectConstants.STATUS_COMPLETE || !this.state.screenObject.required_for_completion
                                        ?
                                        <span>Done</span>
                                        :
                                        <span>Cancel</span>
                                    }
                                </button>
                            </div>
                        </div>
                        <div className={`asset-img-container video`}>
                            {this.state.status !== objectConstants.STATUS_COMPLETE && this.state.screenObject.required_for_completion
                                ?
                                <div className="video-instruction"
                                     dangerouslySetInnerHTML={{__html: this.state.video_instruction}}/>
                                :
                                null
                            }
                            <div className="video-wrapper">
                                <div
                                    data-vimeo-url={`https://player.vimeo.com/video/${this.getVimeoId(this.state.video.src)}`}
                                    data-vimeo-autoplay={this.state.autoplay}
                                    id={`video_${this.state.screenObject.asset_id}`}/>
                            </div>
                            {
                                !this.state.isPlaying
                                    ?
                                    <div className={`video-thumbnail-wrapper ${this.getControlClass()}`}
                                         onClick={this.customPlay} onKeyDown={this.setKeyboardAccessibility}
                                         tabIndex="0"
                                         role="link">
                                        <img src={this.getImagePath(this.state.video.thumbnail)} alt=""/>
                                    </div>
                                    : null
                            }
                            {
                                appHelper.isDefined(this.state.locale.description) && this.state.locale.description.length > 0
                                    ?
                                    <div className="asset-desc">
                                        <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                    </div>
                </div>


        );
    }
}

VimeoVideo.propTypes = {
    screenObject: PropTypes.object.isRequired,
    video: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    onAssetViewed: PropTypes.func.isRequired,
    closeDialog: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
    userData: PropTypes.object.isRequired,
};

VimeoVideo.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VimeoVideo);



/** WEBPACK FOOTER **
 ** ./src/components/objects/video/VimeoVIdeo.js
 **/